import type { Source } from '@epimodev/callbag-doki';
import { createSource } from '@epimodev/callbag-doki/sources/index';
import { Socket } from 'phoenix';

const websocket = <T>(
  url: string,
  channelName: string,
  topic: string,
  params?: object,
  queryOnConnection?: string
): Source<T> =>
  createSource<T>(next => {
    const socket = new Socket(url, params);
    socket.connect();

    const channel = socket.channel(channelName);
    channel.join().receive('error', reason => {
      // Only give up on a PERMANENT rejection (a bad topic will never
      // become valid). Everything else — "join crashed" during a rollout,
      // rate limiting, any transient server error — must keep Phoenix's
      // auto-rejoin so the widget recovers after a pod restart/deploy.
      // (Leaving on transient errors permanently kills the channel: the
      // socket reconnects but the channel never rejoins.)
      if (reason?.reason === 'invalid match id') {
        console.warn('[ws] join permanently rejected, leaving', reason);
        channel.leave();
      }
    });
    channel.on(topic, next);

    if (queryOnConnection) {
      channel.push(queryOnConnection, {}).receive('ok', next);
    }

    socket.onError(console.error);

    return () => {
      channel.leave();
      socket.disconnect();
    };
  });

export { websocket };
